module.exports = __webpack_public_path__ + "img/CRT_Spear-005.65a9861e.png";